import { render } from "./CardsPlanos.vue?vue&type=template&id=23e2ff64&scoped=true"
import script from "./CardsPlanos.vue?vue&type=script&lang=js"
export * from "./CardsPlanos.vue?vue&type=script&lang=js"

import "./CardsPlanos.vue?vue&type=style&index=0&id=23e2ff64&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e2ff64"]])

export default __exports__